// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"7a11b7f9","372":"0b03fe76","443":"70bfba9e","738":"2e027fb7","787":"a9a61a3a","856":"cfd253a5","883":"874f414f"}[chunkId] + ".chunk.js";
};